import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { Transactions2PanelComponent } from './lib/transactions-2-panel.component'
import { Transactions2Key } from './panel-key'

export * from './lib/transactions-2.module'
export * from './panel-key'

export const Transactions2PanelConfig: PanelConfig = {
  key: Transactions2Key,
  title: 'Transactions 2.0',
  description:
    'Compare and reconcile transactions across Enfusion, Prometheus and Clearwater in one configurable workbench.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: Transactions2PanelComponent,
  accessPermission: undefined,
  // Still being built out: available on alpha/beta/stg, withheld from production.
  hideInProduction: true,
}
